import { CreateService, CRUDServiceInterface } from '@/services/service';
import { EmoticonEntity } from '@/entities/emoticon.entity';

export default class EmoticonService
  extends CreateService<EmoticonEntity>('emoticon')
  implements CRUDServiceInterface<EmoticonEntity>
{
  async getMany(): Promise<EmoticonEntity[]> {
    const [items] = await this.apiBuilder.getMany();
    return items;
  }
}
